import React, { useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import CLabel from '../../../Common/CLabel'
import { IconButton } from '@fluentui/react/lib/Button';

import { useTranslation } from "react-i18next";
import SidePanelSections from './SidePanelSections';
import { deleteSectionById } from "../../../../services/sBook/section.service";
import '../../../../styles/css/SectionCard.css'
import { isNullUndefined } from '../../../../common/Helpers';

function SecctionCard(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_BookId = props.bookId;
    const inputParam_SectionItem = props.sectionItem;
    const inputParam_SetterDeleteSection = props.setterDeleteSection;
    
    const inputParam_SelectedCard = props.selectedCard;
    const inputParam_SetterSelectedCard = props.setterSelectedCard;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : false;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;

    
    const inputParam_SectionClassList = props.sectionClassList !== null && props.sectionClassList !== undefined ? props.sectionClassList : [];
    const inputParam_SetterMessage = props.setterMessage !== null && props.setterMessage !== undefined ?  props.setterMessage : "";
    const inputParam_SetterSuccessful = props.setterSuccessful !== null && props.setterSuccessful !== undefined ?  props.setterSuccessful : null;
    const inputParam_SetterShowMessage = props.setterShowMessage !== null && props.setterShowMessage !== undefined ?  props.setterShowMessage : false;
    const inputParam_SetterMessageType = props.setterMessageType !== null && props.setterMessageType !== undefined ?  props.setterMessageType : "";

    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const fontSize = { fontSize: "13px" }

    const onDeleteSection = () => {
        if (inputParam_SectionItem.id > 0) {
            deleteSectionById(inputParam_SectionItem.id).then((response) => {
                if (response.data.succeeded) {
                    inputParam_SetterDeleteSection && inputParam_SetterDeleteSection(inputParam_SectionItem);
                    inputParam_SetterMessage(t('data-lang-msg-operationperformed'));
                    inputParam_SetterSuccessful(true);
                    inputParam_SetterShowMessage(true);
                    inputParam_SetterMessageType("success");
                }
                else {
                    inputParam_SetterMessage(t('data-lang-msg-operationerror'));
                    inputParam_SetterSuccessful(false);
                    inputParam_SetterShowMessage(true);
                    inputParam_SetterMessageType("error");
                }
            }).catch(() => {
                inputParam_SetterDeleteSection && inputParam_SetterDeleteSection(null);
            });            
        } else {
            inputParam_SetterDeleteSection && inputParam_SetterDeleteSection(inputParam_SectionItem);
            inputParam_SetterMessage(t('data-lang-msg-operationperformed'));
            inputParam_SetterSuccessful(true);
            inputParam_SetterShowMessage(true);
            inputParam_SetterMessageType("success");
        }
    }

    const onSelectCardClick = () => {
        inputParam_SetterSelectedCard(inputParam_SectionItem);
    }

    const getSectionClassName = (sectionClassId) => {
        const objSectionClass = inputParam_SectionClassList.find(x => x.key === sectionClassId);

        return !isNullUndefined(objSectionClass) ? objSectionClass.text : t('data-lang-lbl-nodataselected')
    }
    return (
        <Card style={fontSize}  className={`${inputParam_SelectedCard ? (inputParam_SelectedCard.id === inputParam_SectionItem.id ? "selected-card" : "") : ""}`}>
            <Card.Body className="card-section p-2">
                {
                    inputParam_EditMode && inputParam_UserHasConfigRoleAction &&
                    <div style={{cursor: "pointer", float: "right"}}>
                        <IconButton iconProps={{ iconName: 'ChromeClose' }} title={t('data-lang-btn-delete')} onClick={ onDeleteSection } />
                    </div>                    
                }
                <Row style={{cursor: inputParam_SectionItem.id !== 0 ? "pointer" : "default" }} onClick={ inputParam_SectionItem.id !== 0 ? onSelectCardClick : null }>
                    <Col xl={12} className="card-section-body">
                        <Row>
                            <Col>
                                <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-code') } labelValue={ inputParam_SectionItem.sectionCode }  />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-name') } labelValue={ inputParam_SectionItem.name } />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-sectionclass') } labelValue={ getSectionClassName(inputParam_SectionItem.sectionClassId) } />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-requiresapproval') } labelValue={ inputParam_SectionItem.requiresApproval ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') }  />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>
            <SidePanelSections bookId={ inputParam_BookId } sectionId={ inputParam_SectionItem.id } isPanelOpen={ isPanelOpen } setterIsPanelOpen={ setIsPanelOpen } />
        </Card>
    );
}

export default SecctionCard;